export const AUTH_REDIRECT_STORAGE_KEY = 'miaozi.auth.redirectTo'

const localePrefixPattern = /^\/[a-z]{2}(?=\/|$)/
const authScaffoldPattern = /^\/[a-z]{2}\/(?:login|auth\/callback)(?=\/|$)/

export function getLocaleFromPathname(pathname: string) {
  return pathname.split('/').filter(Boolean)[0] || 'en'
}

export function normalizeAuthRedirectTarget(
  target: string | null | undefined,
  locale: string,
  origin = 'https://miaozi.local'
) {
  const fallback = `/${locale}/home`

  if (!target) {
    return fallback
  }

  try {
    const url = new URL(target, origin)
    if (url.origin !== origin) {
      return fallback
    }

    let pathname = url.pathname || '/'
    if (!localePrefixPattern.test(pathname)) {
      pathname = `/${locale}${pathname === '/' ? '/home' : pathname}`
    }

    if (pathname === '/' || pathname === `/${locale}`) {
      return fallback
    }

    if (authScaffoldPattern.test(pathname)) {
      return fallback
    }

    return `${pathname}${url.search}${url.hash}`
  } catch {
    return fallback
  }
}
